import { ApiService } from '~/service/service.api';
import { IngredientImportDto } from '~/shared/dto/admin/ingredient.dto';
import { IngredientId } from '~/shared/dto/id';
import { Model } from '~/shared/service/service.base';
import { ImportModel } from './model.import';
import { TranslationModel, Translations } from './model.translation';

type IngredientRowType = Omit<InstanceType<typeof IngredientImportDto>, 'id'> &
	Translations & { ingredientId: IngredientId };

@Model()
export class IngredientImportModel extends ImportModel<IngredientImportDto> {
	constructor(
		api: ApiService,
		private readonly tr: TranslationModel,
	) {
		super(IngredientImportDto, api.ingredientImport.bind(api));
	}

	getItemFromRow(row: IngredientRowType): IngredientImportDto {
		return {
			id: this.parseNumber(row.ingredientId) as IngredientId,
			name: row.name,
			casNumber: row.casNumber,
			vendor: row.vendor,
			description: row.description,
			translations: this.tr.getTranslationsFromRow(row),
		};
	}

	downloadTemplate = () => {
		const example: IngredientRowType = {
			ingredientId: 62,
			name: 'Example Ingredient (en)',
			casNumber: '123-45-6',
			vendor: 'Example Vendor',
			description: 'A short description',
		};
		this.tr.addTranslationsToExample(example);
		this.buildAndDownloadCSV('ingredient-import-template.csv', example);
	};
}
